import Container from '@/components/Container'
import HtmlContent from '@/components/HtmlContent'
import JoinUrbanClub from '@/components/JoinUrbanClub'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { arrowRightIcon, scheme, zheka2 } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import { Link } from 'react-router-dom'
import style from './styles/education.module.scss'

const Education = (): React.ReactElement => {
  const page = usePage()
  const { object } = page.init_state
  const { menus } = page?.init_state?.global

  const education = menus.education
  return (
    <>
      <Title type='h1' hidden>
        {object.title}
      </Title>
      <Container>
        <Section>
          <div className={style.education_top}>
            <div className={style.education_left}>
              <Title type='h2' theme='h1' className={style.education__title}>
                {object.title}
              </Title>
              <HtmlContent
                className={style.education__text}
                content={object.detail}
              />
            </div>
            <img
              src={zheka2}
              width='290px'
              height='306px'
              alt='Жэка'
              className={style.education__image}
            />
          </div>
          <ul className={style.education_cards}>
            {education !== undefined
              ? education.map((education, index) => {
                return (
                  <li key={education.id} className={style.education__card}>
                    <Link
                      to={education.property_link_value}
                      className={style.card__link}
                      style={{ backgroundImage: `url(${String(scheme)})` }}
                    >
                      <Title
                        type='h3'
                        theme='h2'
                        className={style.card__title}
                      >
                        {education.name}
                      </Title>

                      <HtmlContent className={style.card__text} content={education.preview_text} />
                      <GxIcon
                        src={arrowRightIcon}
                        className={style.card__icon}
                      />
                      <img
                        src={education.property_icon_value}
                        width='460px'
                        height='398px'
                        alt=''
                        className={style.card__image}
                      />
                    </Link>
                  </li>
                )
              })
              : null}
          </ul>
        </Section>
      </Container>

      <JoinUrbanClub />
    </>
  )
}

export default Education
